import { useTranslation } from "react-i18next";

import rating from "@/assets/images/landing-page/rating.png";
import expertise from "@/assets/images/landing-page/expertise.png";
import padlock from "@/assets/images/landing-page/padlock.png";

import LandingCertificationLogos from "./LandingCertificationLogos";

export default function LandingExpertsSection() {
	const { t } = useTranslation();

	const features = [
		{
			icon: rating,
			alt: t("questionnaire.landingExpertsSection.features.0.alt"),
			text: t("questionnaire.landingExpertsSection.features.0.text"),
		},
		{
			icon: expertise,
			alt: t("questionnaire.landingExpertsSection.features.1.alt"),
			text: t("questionnaire.landingExpertsSection.features.1.text"),
		},
	];

	return (
		<section className="relative w-full px-4 md:px-6 lg:px-8 ">
			<div className="pb-[144px] w-full max-w-[1420px] mx-auto my-16 sm:my-[7.5rem] text-center  px-4 md:px-16">
				<div className="flex flex-col lg:flex-row justify-center  gap-12 lg:gap-[56px] mb-[3rem] sm:mb-[7rem]">
					<div className="w-full lg:max-w-[694px] text-left flex flex-col gap-[40px]">
						<div className="flex flex-col gap-[24px]">
							<p className="text-[40px] font-semibold leading-[120%] font-urbanist">
								{t("questionnaire.landingExpertsSection.title")}
							</p>
							<p className="text-[18px] leading-[150%] font-urbanist font-normal text-[#626373]">
								{t("questionnaire.landingExpertsSection.description")}
							</p>
						</div>

						<div className="flex flex-col gap-4">
							{features.map((item, index) => (
								<div
									key={index}
									className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-4 text-center sm:text-left"
								>
									<img alt={item.alt} src={item.icon} />
									<p className="text-[20px] font-medium leading-[140%] font-urbanist">
										{item.text}
									</p>
								</div>
							))}
						</div>

						<div className="flex flex-col gap-4 border-l-[6px] border-[#4680FC] bg-[#F7F8FB] rounded-[16px] p-6 md:p-8 w-full lg:w-[694px]">
							<div className="flex flex-col sm:flex-row gap-4">
								<img
									alt={t("questionnaire.landingExpertsSection.dataPrivacy.padlockAlt")}
									className="w-[24px] h-[24px]"
									src={padlock}
								/>
								<div className="flex flex-col gap-2">
									<p className="text-[18px] font-semibold leading-[150%] font-urbanist">
										{t("questionnaire.landingExpertsSection.dataPrivacy.title")}
									</p>
									<p className="text-[18px] font-normal leading-[150%] font-urbanist">
										{t("questionnaire.landingExpertsSection.dataPrivacy.description")}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<LandingCertificationLogos />
			</div>
		</section>
	);
}
